import { AuthService } from '$services/auth/auth.service';
import { Component, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-warning-popup',
  templateUrl: './warning-popup.component.html',
  styleUrls: ['./warning-popup.component.css']
})
export class WarningPopupComponent {

  static version: string =  '1.0'; // change this version if warning change
  checkboxChecked = false;
  popupVisible = true;
  @ViewChild('popup', { static: true }) popupRef!: ElementRef;

  constructor(private readonly authService: AuthService,
              private readonly changeDetectorRef: ChangeDetectorRef) { }


  doNotShowAgain(arg0: boolean) {

    this.authService.setHaveWatchedPopup(WarningPopupComponent.version);
    this.checkboxChecked = arg0;
  }

  closePopup() {
    this.popupVisible = false;
    this.changeDetectorRef.detectChanges();
  }

}
